import { FC } from 'react';
import cls from './suggestion.module.scss';
import { Icon } from 'shared/ui/icon/icon';
import { ICONS } from 'shared/constants/images';
import { Card } from 'shared/ui/card/card';
import { useTranslation } from 'hooks';
import { track } from 'utils/mixpanel';
import { RuleExample } from 'store/api/apiTypes';
import { WrappedIcon } from '../wrapped-icon/wrapped-icon';
import { linkifyText } from 'shared/helpers/linkifyText';
import { ExternalLink } from 'shared/ui/external-link/external-link';

interface AnalysisItemProps {
  item: RuleExample;
  index: number;
  isTrial?: boolean;
  ruleName?: string;
  productNumber?: number;
}

export const AnalysisItem: FC<AnalysisItemProps> = ({
  index,
  item,
  ruleName,
  productNumber,
  isTrial = false,
}: AnalysisItemProps) => {
  const { t } = useTranslation();
  const trackLinkClick = (link?: string) => {
    track('AIS:PROD_CRD_ANALYSIS_SUBSECTION-SOURCE_LINK-CLICKED', {
      is_trial: isTrial,
      type: ruleName,
      card_type: 'Website Analysis',
      link: link,
      ...(productNumber && { product: productNumber }),
    });
  };
  return (
    <Card className={cls.websiteCard}>
      <div className={cls.column}>
        <div className={cls.case}>
          <h4>Case {index + 1}</h4>
          <p>{linkifyText(item?.improvement_rationale ?? '')}</p>
        </div>
        <ExternalLink
          href={item?.link}
          onClick={() => trackLinkClick(item?.link)}
        >
          <Icon pathToIcon={ICONS.link} size={18} /> {item?.link}
        </ExternalLink>
      </div>
      <div className={cls.right}>
        <div className={cls.status}>
          <WrappedIcon pathToIcon={ICONS.cross} color={'red'} size={24} />
          <div>
            <h4>{t('currentVersion')}</h4>
            <p>{linkifyText(item?.current_implementation ?? '')}</p>
          </div>
        </div>
        <div className={cls.status}>
          <WrappedIcon
            pathToIcon={ICONS.checkMarkGreen}
            color={'green'}
            size={24}
          />
          <div>
            <h4>{t('improvementSuggestion')}</h4>
            <p>{linkifyText(item?.improved_version ?? '')}</p>
          </div>
        </div>
      </div>
      {isTrial && <div className={cls.trialOverlay}></div>}
    </Card>
  );
};
